import React, { useState } from 'react'
import { useRequest } from 'ahooks'
import Button from '@/components/button/button'
import { Column, Expaned } from '@/components/layout/layout'
import $msg from '@/utils/message'
import { getLsMemberImportInfo } from '../api'
import MemberHeaderActions from '../member-header-actions'
import MemberNotice from '../member-notice'
import ImportRecord from './import-record'
import RepeatMemberHandler from './repeat-member-handler'
import ShopImport from './shop-import'
import TableImport from './table-import'
import { getRepeatImportActionText, hasRepeatImportReviewEntry } from './repeat-member-utils'

import './member-import.scss'

const importTabs = [
    { id: 0, name: '老零售店铺导入' },
    { id: 1, name: '表格导入' },
    { id: 2, name: '导入记录' },
]

const MemberImport: React.FC = () => {
    const [repeatVisible, setRepeatVisible] = useState(false)
    const [activeTab, setActiveTab] = useState(0)
    const importInfoReq = useRequest(getLsMemberImportInfo, {
        onError: e => $msg('error', e.message || '获取导入状态失败'),
    })
    const importStatus = importInfoReq.data?.import_status
    const repeatRecordId = importInfoReq.data?.record?.id
    const hasRepeatEntry = hasRepeatImportReviewEntry(importInfoReq.data)
    const refreshImportStatus = () => importInfoReq.refresh()

    return (
        <Column className="member-import">
            <MemberHeaderActions>
                <Button
                    className="member-manage__toolbar-button"
                    types="primary"
                    loading={importInfoReq.loading}
                    onClick={() => importInfoReq.refresh()}
                >
                    刷新导入状态
                </Button>
            </MemberHeaderActions>
            <Expaned className="member-import__body">
                <div className="member-import__tabs" role="tablist" aria-label="批量导入方式">
                    {importTabs.map(item => (
                        <button
                            key={item.id}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === item.id}
                            className={`member-import__tab ${
                                activeTab === item.id ? 'member-import__tab--active' : ''
                            }`}
                            onClick={() => setActiveTab(item.id)}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>
                {importStatus === 0 ? (
                    <MemberNotice className="member-import__status">
                        正在导入 {importInfoReq.data?.ls_shop_name || '会员'}，可稍后刷新查看结果。
                    </MemberNotice>
                ) : null}
                {hasRepeatEntry ? (
                    <MemberNotice
                        className="member-import__status"
                        type="warning"
                        action={
                            <Button types="default" onClick={() => setRepeatVisible(true)}>
                                {getRepeatImportActionText(importInfoReq.data)}
                            </Button>
                        }
                    >
                        存在待处理或需核对的重复会员/卡号冲突，请查看详情后再继续导入。
                    </MemberNotice>
                ) : null}
                <div className="member-import__workspace">
                    <div className="member-import__tab-content">
                        {activeTab === 0 ? (
                            <ShopImport importing={importStatus === 0} onImportStarted={refreshImportStatus} />
                        ) : null}
                        {activeTab === 1 ? (
                            <TableImport importing={importStatus === 0} onImportStarted={refreshImportStatus} />
                        ) : null}
                        {activeTab === 2 ? <ImportRecord /> : null}
                    </div>
                </div>
                <RepeatMemberHandler
                    visible={repeatVisible}
                    recordId={repeatRecordId}
                    onCancel={() => setRepeatVisible(false)}
                    onSuccess={() => {
                        setRepeatVisible(false)
                        importInfoReq.refresh()
                    }}
                />
            </Expaned>
        </Column>
    )
}

export default MemberImport
